import { create } from "zustand";
import { useFetchHQandProductWiseSlice } from "../slices/PrimarySalesSlices/fetchHQandProductWiseSlice";
interface PrimarySalesInterface
  extends ReturnType<typeof useFetchHQandProductWiseSlice> {}

export const PrimarySalesStore = create<PrimarySalesInterface>((...a) => ({
  ...useFetchHQandProductWiseSlice(...a),
}));
